// extracted by mini-css-extract-plugin
export default {"empty":"emptyBalance_empty__h99sC"};